<template>
	<div class="post-page-container page pt-5">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-skeleton-loader v-if="this.isLoading" v-bind="attrs" type="card" />
			<div v-else-if="forum">
				<Forum :forum="this.forum" />
				<CreatePostModal
					ref="createPostModal"
					:show="isShowCreatePostModal"
					:categoryId="categoryId"
					:editableForum="forum"
					:edit="isEdit"
					@closeModal="closeCreatePostModal"
				/>

				<v-btn
					v-show="isShowCreatePostButton"
					@click="openCreatePostModal"
					bottom
					right
					class="add-post-button"
					fixed
					fab
				>
					<Icon type="plus" :size="24" color="#ffffff" />
				</v-btn>

				<v-btn v-show="isVisible" @click="scrollToTop" bottom right fixed fab>
					<v-icon>mdi-chevron-up</v-icon>
				</v-btn>
			</div>
		</div>
		<v-dialog v-model="isCreate" max-width="588px" width="100%" persistent>
			<v-card class="exhibitor-page__modal">
				<div class="exhibitor-page__modal__title">
					Please join the community to start discussions.
				</div>
				<button type="button" @click="isCreate = false" class="exhibitor-page__modal__btn">
					OK
				</button>
			</v-card>
		</v-dialog>
		<ConfirmActionModal
			:show="isDeleteModalShow"
			@closeModal="togglePostDeleteModal"
			@confirmAction="deletePost"
			title="Are you sure you want to delete this discussion? This action cannot be undone."
			actionName="Delete"
			:isLoading="isPostUpdating"
		/>
		<ConfirmActionModal
			:show="isReporting"
			v-model="reportText"
			@confirmAction="sendReports"
			@closeModal="closeReportModal"
			title="Report Inappropriate."
			actionName="Send"
			:isLoading="isLoadingReport"
			:isReport="true"
		/>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import Forum from '@/components/Forum/Forum.vue'
import CreatePostModal from '@/components/Modals/CreateForumPostModal.vue'
import penIcon from '@/assets/images/icon-pen.svg'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'
import { EventBus } from '@/services/event-bus'
import ConfirmActionModal from '@/components/Modals/ConfirmActionModal.vue'

export default {
	name: 'ForumPage',
	mixins: [Block, Dwh],
	components: {
		ConfirmActionModal,
		CreatePostModal,
		Forum,
		PageBlocked,
	},
	data() {
		return {
			attrs: {
				elevation: 0,
			},
			reportText: '',
			penIcon,
			isVisible: false,
			isShowCreatePostButton: true,
			isShowCreatePostModal: false,
			isEdit: false,
			pageBlockedName: 'forums',
			isCreate: false,
		}
	},
	computed: {
		...mapGetters('forum', [
			'forum',
			'isLoading',
			'modalCategories',
			'isReporting',
			'report',
			'isLoadingReport',
			'reportError',
		]),
		...mapGetters('auth', ['profile']),
		...mapGetters('advertisement', ['isDeleteModalShow']),
		...mapGetters('post', ['isPostUpdating']),

		categoryId() {
			if (this.$route.params.id !== undefined) {
				return this.forum.thread_category_id
			}

			return null
		},
		controlPanelIsVisible() {
			return this.profile?.user_id === this.forum?.user?.user_id
		},
	},
	methods: {
		...mapActions('forum', [
			'getForum',
			'getModalCategories',
			'resetModalCategories',
			'reportingModal',
			'sendReport',
		]),
		...mapActions('advertisement', ['setMyPosts', 'togglePostDeleteModal']),
		...mapActions('app', ['setPageTitle']),
		...mapActions('post', ['removePost']),
		...mapActions('auth', ['showAlert']),
		dwhSendReport(text) {
			this.sendTrigger({
				category: 'Moderation',
				action: 'click_submit_report_discussion',
				module: 'Forums / Communities',
				title: this.forum.thread_title,
				id1: this.forum.thread_id,
				data: text,
			})
		},
		async sendReports() {
			if (!this.reportText || !this.reportText.trim()) {
				this.showAlert({
					type: 'error',
					message: 'Report cannot be empty.',
				})
				return
			}
			try {
				await this.sendReport({
					inappropriate_status: 1,
					inappropriate_time: Math.floor(Date.now() / 1000),
					inappropriate_content_type: 1,
					inappropriate_content_id: this.$route.params.id,
					inappropriate_text: this.reportText,
				})

				this.showAlert({
					type: 'success',
					message: 'Report sent',
				})
				this.dwhSendReport(this.reportText)

				this.reportText = ''
				this.closeReportModal()
			} catch (e) {
				this.showAlert({
					type: 'error',
					message: 'Failed to send report',
				})
			}
		},
		closeReportModal() {
			this.reportingModal()
		},
		dwhDeleteClickTrigger() {
			this.sendTrigger({
				category: 'Moderation',
				action: 'click_confirm_delete_discussion',
				module: 'Forums / Communities',
				title: this.forum.thread_title,
				id1: this.forum.thread_id,
			})
		},
		toggleDeleteModal() {
			this.togglePostDeleteModal()
		},
		async deletePost() {
			const response = await this.removePost(this.forum.thread_id)
			if (response) {
				this.toggleDeleteModal()
				this.$router.back()
			}
			this.dwhDeleteClickTrigger()
		},
		toggleVisibility() {
			this.isVisible = window.scrollY > 1000
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		},
		checkScreenWidth() {
			this.isShowCreatePostButton = window.innerWidth >= 1264
		},
		openCreatePostModal() {
			this.isShowCreatePostModal = true
		},
		closeCreatePostModal() {
			this.isEdit = false
			this.isShowCreatePostModal = false
		},
		async openEditPostModal() {
			this.resetModalCategories()
			await this.getModalCategories({
				query: `/view?category_type=1&id=${this.categoryId}`,
				page: 1,
			})
			const isBookmarked = this.modalCategories[0].bookmark.is_bookmarked
			if (!isBookmarked) {
				this.isCreate = true
				return
			}
			this.isEdit = true
			this.isShowCreatePostModal = true
		},
		getForumById() {
			this.getForum(this.$route.params.id)
		},
		myPost(value) {
			this.setMyPosts(value)
		},
	},
	watch: {
		controlPanelIsVisible: {
			handler(value) {
				this.myPost(value)
			},
			immediate: true,
		},
		isLoading(newValue, oldValue) {
			if (newValue !== oldValue) {
				if (!newValue && this.$route.query.toBottom !== undefined) {
					setTimeout(() => {
						window.scrollTo({
							top: document.body.scrollHeight,
							behavior: 'smooth',
						})
					}, 100)
				}
			}
		},
		forum(newValue) {
			if (newValue) {
				this.sendTrigger({
					category: 'Discussion Post',
					action: 'view_forum_post',
					module: 'Forums / Communities',
					title: this.forum.thread_title,
					id1: this.forum.thread_id,
					id2: this.forum.thread_category_id,
				})
				const currentTitle = this.$route.query.title

				if (this.forum.thread_title && currentTitle !== this.forum.thread_title) {
					this.$router.replace({
						query: {
							...this.$route.query,
							title: this.forum.thread_title,
						},
					})
				}
			}
		},
	},
	created() {
		EventBus.$on('openEditForumModal', this.openEditPostModal)
		if (this.$route.params.id !== undefined && (!this.isBlocked || this.isBlocked === null)) {
			this.getForumById()
		}
	},
	mounted() {
		this.setPageTitle('Discussion Details')
		window.scrollTo(0, 0)
		window.addEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth)
	},
	beforeDestroy() {
		this.setMyPosts(false)
		this.setPageTitle('')
		EventBus.$off('openEditForumModal', this.openEditPostModal)
		window.removeEventListener('scroll', this.toggleVisibility)
		window.removeEventListener('resize', this.checkScreenWidth)
	},
}
</script>

<style lang="scss">
.post-page {
	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}
}

@media screen and (min-width: 1200px) {
	.post-page-container {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.post-page-container {
		max-width: 600px;
	}
}

.post {
	&__search {
		background: white;
		height: 54px;
		border-radius: 10px;
		border: 1px solid rgb(230, 230, 230);
		max-width: 600px;
	}

	&__fake-btn-modal {
		&-container {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 54px;
			background: rgb(255, 255, 255);
			border: 1px solid rgb(230, 230, 230);
			border-radius: 10px;
			padding: 20px 15px;
			max-width: 600px;
			cursor: pointer;

			color: rgb(160, 160, 160);
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			letter-spacing: -0.43px;
		}
	}

	@media screen and (max-width: 1264px) {
		&__search {
			max-width: none;
			width: 100%;
		}
		&__fake-btn-modal-container {
			max-width: none;
			width: 100%;
		}
	}
}

.control-btn {
	font-size: 14px;
	font-weight: 700;
	font-family: Montserrat, sans-serif;
	text-transform: capitalize;
	text-decoration: underline;
	background-color: transparent !important;
	line-height: 17.07px;

	&__edit {
		color: #0055a3 !important;
	}
}
</style>
